import { render } from "./RiProdoffering108.vue?vue&type=template&id=85c67d82"
import script from "./RiProdoffering108.vue?vue&type=script&lang=js"
export * from "./RiProdoffering108.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering108.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85c67d82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85c67d82', __exports__)) {
    api.reload('85c67d82', __exports__)
  }
  
  module.hot.accept("./RiProdoffering108.vue?vue&type=template&id=85c67d82", () => {
    api.rerender('85c67d82', render)
  })

}


export default __exports__